import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { Dialog, DialogHeader, DialogBody, DialogFooter, Button } from '@material-tailwind/react';
import { FunctionComponent } from 'react';

/**
 * Ce composant permet d'afficher une Modale pour que l'administrateur puisse rétracter un devis.
 *
 * @param visible - Précise si la modale et ouverte ou non. Provient du parent.
 * @param setVisible - Accesseur qui modifie la visibilité de la modale. Provient du parent.
 * @param handleTraite - Callback qui permet de se retracter sur un devis. Provient du parent.
 */
export const ModalTraitementDevisAdmin: FunctionComponent<{
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleTraite: () => void;
}> = ({ visible, setVisible, handleTraite }) => {
  return (
    <Dialog open={visible} size='xs' handler={setVisible}>
      <DialogHeader>Traitement du devis</DialogHeader>
      <DialogBody divider>
        <div className='text-secondary-1 flex items-start mb-3'>
          <ArrowRightIcon className='flex-none w-5 h-5 mr-3' strokeWidth={2} />
          <div className='grow text-sm'>Ceci informera l'entreprise que vous avez traité le devis. Confirmer ?</div>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button variant='text' color='gray' onClick={() => setVisible(false)} className='mr-1 !rounded-full'>
          Annuler
        </Button>
        <Button
          variant='filled'
          color='orange'
          onClick={() => {
            handleTraite();
            setVisible(false);
          }}>
          Confirmer
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
